// The Photon product updates feed. Entries are no longer edited here - they
// ship inside the release artifacts (data/photon/releases/*.json, in each
// release's changes[] array) and are aggregated by
// scripts/generate-photon-release-data.mjs. /photon/updates, the RSS and
// JSON feeds, and the "Latest updates" section on /photon all render from
// the aggregated feed.

import { UPDATES } from "./generated/release-data";
import type { Update, UpdateType } from "./release-types";

export type { Update, UpdateType };
export { UPDATES };

export const UPDATE_TYPES: UpdateType[] = [
  "model",
  "hardware",
  "capability",
  "performance",
  "runtime",
  "compatibility",
  "fix",
  "deprecation",
];

export const UPDATE_TYPE_LABELS: Record<UpdateType, string> = {
  model: "Model support",
  hardware: "Hardware support",
  capability: "Capability",
  performance: "Performance",
  runtime: "Runtime",
  compatibility: "Compatibility",
  fix: "Fix",
  deprecation: "Deprecation",
};

/** Entries for one Photon version, preserving feed order (newest first). */
export const updatesForVersion = (version: string) =>
  UPDATES.filter((u) => u.version === version);

/** Version groups in feed order: [{ version, date, entries }]. */
export const versionGroups = (entries: Update[]) => {
  const groups: { version: string; date: string; entries: Update[] }[] = [];
  for (const entry of entries) {
    const group = groups.find((g) => g.version === entry.version);
    if (group) {
      group.entries.push(entry);
    } else {
      groups.push({ version: entry.version, date: entry.date, entries: [entry] });
    }
  }
  return groups;
};
